import styled, { css } from "styled-components";

const wrapperModifiers = {
  primary: (theme) => css`
    background-color: ${theme.colors.lineBlue};
  `,
  secondary: (theme) => css`
    background-color: ${theme.colors.grayThird};
  `,
};

export const Wrapper = styled.button`
  ${({ theme, button = "primary" }) => css`
    width: 20.1rem;
    height: 4.1rem;
    color: ${theme.colors.white};
    border-radius: 0.6rem;

    font-size: 1.6rem;
    font-family: 500;
    line-height: 1.28;

    ${!!button && wrapperModifiers[button](theme)};
  `}
`;
